/** MMP 전용 CSS */
import '../css/base.css'
import '../css/layout.css'
import '../css/component.css'
import '../css/utils.css'
import '../css/promotion.css'
import '../css/detail.css'
import '../css/course.css'
import '../css/page.css'
import '../css/motion-effects.css'



// WEBPACK FOOTER //
// ./src/assets/js/StyleModule.js